import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

interface CoachProfileProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  coach: {
    id: string;
    name: string;
    bio?: string;
    specialties?: string[];
    experience?: string;
    image?: string;
  } | null;
    }

export function CoachProfile({ open, onOpenChange, coach }: CoachProfileProps) {
  if (!coach) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Coach Profile</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {coach.image && (
            <img
              src={coach.image}
              alt="Coach"
              className="w-32 h-32 rounded-full object-cover mx-auto"
            />
          )}

          <h2 className="text-xl font-semibold text-center">{coach.name}</h2>

          {coach.bio && (
            <p className="text-sm text-muted-foreground">{coach.bio}</p>
          )}

          {coach.experience && (
            <div>
              <h3 className="font-semibold">Experience</h3>
              <p className="text-sm text-muted-foreground">
                {coach.experience}
              </p>
            </div>
          )}

          {coach.specialties && coach.specialties.length > 0 && (
            <div>
              <h3 className="font-semibold">Specialties</h3>
              <ul className="list-disc ml-5 text-sm text-muted-foreground">
                {coach.specialties.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex justify-end pt-4">
            <Button onClick={() => onOpenChange(false)}>Close</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
